module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<li class=\"pv-h\">\n    <button href=\"javascript:void(0);\" class=\"filter js-filter\">\n        <img class=\"avatar-image\" src=\"<%= selected.pic %>\" alt=\"\"><span class=\"title selected-title\"><%= selected.title %></span> \n    </button>\n    <ul class=\"content\">\n        <%\n        for (var i = 1; i < data.length; i++) { %>\n        <li><a href=\"javascript:void(0);\" data-index=\"<%= i %>\" data-value=\"<%= data[i].value %>\" data-url=\"<%= data[i].url %>\">\n                <% if (data[i].kidsBadge) { %>\n                <img class=\"kids-badge\" src=\"<%= data[i].kidsBadge %>\" alt=\"\">\n                <% } %>\n                <%\n                customClass = ''\n                if (data[i].customClass){\n                    customClass = data[i].customClass\n                }%>\n                <img class=\"avatar-image <%=customClass%>\" src=\"<%= data[i].pic %>\" alt=\"\"><span class=\"title\"><%= data[i].title %></span> \n            </a>\n        </li>\n        <% } %>\n    </ul>\n</li>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/filters/__profiles.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<li class=\"pv-h\">\n    <button href=\"javascript:void(0);\" class=\"filter js-filter\">\n        <img class=\"avatar-image\" src=\"")
    ; __line = 3
    ; __append(escapeFn( selected.pic ))
    ; __append("\" alt=\"\"><span class=\"title selected-title\">")
    ; __append(escapeFn( selected.title ))
    ; __append("</span> \n    </button>\n    <ul class=\"content\">\n        ")
    ; __line = 6
    ; 
        for (var i = 1; i < data.length; i++) { 
    ; __line = 7
    ; __append("\n        <li><a href=\"javascript:void(0);\" data-index=\"")
    ; __line = 8
    ; __append(escapeFn( i ))
    ; __append("\" data-value=\"")
    ; __append(escapeFn( data[i].value ))
    ; __append("\" data-url=\"")
    ; __append(escapeFn( data[i].url ))
    ; __append("\">\n                ")
    ; __line = 9
    ;  if (data[i].kidsBadge) { 
    ; __append("\n                <img class=\"kids-badge\" src=\"")
    ; __line = 10
    ; __append(escapeFn( data[i].kidsBadge ))
    ; __append("\" alt=\"\">\n                ")
    ; __line = 11
    ;  } 
    ; __append("\n                ")
    ; __line = 12
    ; 
                customClass = ''
                if (data[i].customClass){
                    customClass = data[i].customClass
                }
    ; __line = 16
    ; __append("\n                <img class=\"avatar-image ")
    ; __line = 17
    ; __append(escapeFn(customClass))
    ; __append("\" src=\"")
    ; __append(escapeFn( data[i].pic ))
    ; __append("\" alt=\"\"><span class=\"title\">")
    ; __append(escapeFn( data[i].title ))
    ; __append("</span> \n            </a>\n        </li>\n        ")
    ; __line = 20
    ;  } 
    ; __append("\n    </ul>\n</li>")
    ; __line = 22
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/filters/__profiles.tpl"

}